import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Select2Data } from 'ng-select2-component';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { QueryService } from 'src/app/providers/query/query.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import Swal from 'sweetalert2';
declare let $: any;
@Component({
  selector: 'app-query',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.scss']
})
export class QueryComponent implements OnInit {
  @ViewChild('myInput') myInput: ElementRef;
  User: Select2Data = [{ label: 'Select', value: '', disabled: true }];
  userContact: any = {};
  userAdd: any = {};
  categList: any = [];
  categListStatus: any;
  subCategList: any = [];
  subCategstatus: any;
  subCateg2List: any = [];
  subCateg2status: any;
  Img: any = [];
  queryForm: FormGroup;
  submitted = false;
  loading = false;
  LoggedId: any = '';
  empid: any = '';
  isbehalf: any = false;
  Empname: any = '';
  Empcontact: any = {};
  result: any = [];
  result2: any = [];
  actualManager = false;
  isManager = false;
  response: any;
  getAccType: any;
  getBankName: any;
  userDetailsForm: boolean;
  cate: any  = '';
  subcate: any  = '';
  isRhr = false;
  qryEmp: any;
  placeholderText = 'Enter Comments(Candidate Designation, Profile, Role suitability, Site Mapping and Location)';
  excelfile: any = [];
  // addAppForm = new FormData();
  searchEmps: any = [];
  empID;
  subscription: any  = [];
  @ViewChild('querySrch', { static: true }) querySrch: ElementRef;
  excelCC: any = [];
  userPersnalDetailsForm = false;
  reiumbureseBankForm = false;
  pwdData: any = [];
  maritalData: any = [];
  genderData: any = [];
  basicForm: FormGroup;
  departmentData: any = [];
  FName: any;
  LName: any;
  Dob: any;
  Gender: any;
  Marital: any;
  IsPwd: any;
  Deprt: any;
  Empstatus:any;
  constructor(
    private notifyService: NotificationService,
    private queryServe: QueryService,
    private generalServ: GeneralService,
    private router: Router,
    private dashService: DashboardService,
    private route: ActivatedRoute,
    public elem: ElementRef

    ) {
    this.queryForm = new FormGroup({
      emp_id: new FormControl(''),
      emp: new FormControl(''),
      category: new FormControl('', Validators.required),
      sub_cat1: new FormControl('', Validators.required),
      sub_cat2: new FormControl(''),
      remark: new FormControl('', Validators.required),
      priority: new FormControl('low', Validators.required),
      is_behalf: new FormControl(),
      is_excel: new FormControl(),
      excel_data: new FormControl(),
      doc: new FormControl(''),
      acc_type: new FormControl(''),
      bank_id: new FormControl(''),
      acc_no: new FormControl(''),
      ifsc_code: new FormControl(''),
      
      rem_acc_type: new FormControl(''),
      rem_bank_id: new FormControl(''),
      rem_acc_no: new FormControl(''),
      rem_ifsc_code: new FormControl(''),

      first_name: new FormControl(''),
      last_name: new FormControl(''),
      dob: new FormControl(''),
      gender: new FormControl(''),
      marital: new FormControl(''),
      is_pwd: new FormControl(''),
      depart: new FormControl(''),
      
    });


  }

  // tslint:disable-next-line: typedef
  get queryCont() {
    return this.queryForm.controls;
  }


  ngOnInit(): void {
    this.rhrFind();
    this.userDetailsForm = false;
    this.LoggedId = localStorage.getItem('user');

    this.dashService.getMyReporties().subscribe(res => {
      this.response = res;
      this.isManager = this.response.is_behalf_user;
      this.actualManager = this.response.is_behalf_user;

      if (this.response.status) {
        this.User = this.response.data;
        // this.response.data.forEach(element => {
        //    this.onBehalfEmp.push({label: element.name, value: element.id});
        // });
      } else {
        // this.notifyService.showInfo(this.response.msg, 'Info!');
      }
    }, err => {
      // this.notifyService.showInfo('Users Not Found!', 'Info!');
    });

    this.get_emp(this.LoggedId);
    this.queryServe.getCategory('1').subscribe(res => {
      this.categListStatus = res;
      if (this.categListStatus.status) {
        this.categList = this.categListStatus.data;
      } else {
        this.notifyService.showInfo(this.categListStatus.msg, 'Info!');
      }
    }, err => {
      this.notifyService.showError('Internal Server Error', 'Error!');
    });

    this.getBanks();
    this.getAccountTypes();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.cate = parseInt(params.get('cat'));
      this.subcate = parseInt(params.get('subcate'));

      if(isNaN(this.cate) === false && isNaN(this.subcate) === false){
        this.queryForm.patchValue({
             category : this.cate,
          });
        this.getGeneralSubCategory(this.cate);
      }else{
        this.cate = '';
        this.subcate = '';
      }
    });

    // this.basicFormField();

  }


  getPWDList(): void {
    this.dashService.getOptions('9').subscribe( res => {
      this.result = res;
      this.pwdData = this.result.data;
    });
  }
  getMaritalList(): void {
    this.dashService.getOptions('11').subscribe( res => {
      this.result = res;
      this.maritalData = this.result.data;
    });
  }
  getGenderList(): void {
    this.dashService.getOptions('1').subscribe( res => {
      this.result = res;
      this.genderData = this.result.data;
    });
  }
  getDepartments(): void {
    this.generalServ.getDepartments().subscribe( res => {
      this.result = res;
      this.departmentData = this.result.data;
    });
  }
  // get basicData() { return this.basicForm.controls; }
//   basicFormField(): void {
//    this.basicForm = new FormGroup({
//     first_name: new FormControl(''),
//     last_name: new FormControl(''),
//     father_name: new FormControl(''),
//     dob: new FormControl(''),
//     gender: new FormControl(''),
//     marital: new FormControl(''),
//     is_pwd: new FormControl(''),
//     user_id: new FormControl(''),
//    });
//  }

  // ngAfterViewInit(): void {
  //   fromEvent(this.querySrch.nativeElement, 'keyup').pipe(
  //     map((event: any) => {
  //         return event.target.value;
  //     })
  //     , filter(res => res.length > 2)
  //     , debounceTime(1000)
  //     , distinctUntilChanged()
  // ).subscribe((text: string) => {
  //     this.generalServ.getEmps({key : text}).subscribe(res => {
  //       console.log(res);
  //       this.searchEmps = res.data;
  //     },
  //     err => {

  //     });
  //     });

  // }//end of view init


  rhrFind(): void {
    this.queryServe.isRhr().subscribe(res => {
      if (res.is_rhr == 1) {
      this.isRhr = true;
    } else {
      this.isRhr = false;
      }
    });
  }

  searchEmp(): void {
    this.queryForm.get('emp_id').reset();
    this.qryEmp = '';
    if (!this.queryForm.get('emp').value) {
      this.notifyService.showInfo('Please Enter Employee ID', 'Info!');
      return;
    } else {
      this.generalServ.searchEmployee(this.queryForm.get('emp').value).subscribe(res => {
        if (res.status) {
          this.queryForm.patchValue({
            emp: res.data[0].username + '-' + res.data[0].name,
            emp_id: res.data[0].id
          });
          this.qryEmp = res.data[0].id;
          // this.addAppForm.append('user_id', res.data[0].id);
        } else {
          this.queryForm.patchValue({
            emp: '',
            emp_id: ''
          });
          this.notifyService.showError(res.msg, 'Info!');
        }
      });
    }
  }


  is_on_behalf(ev): void {
    this.queryForm.patchValue({
      emp: '',
      emp_id: ''
    });
    if (ev) {
      this.isbehalf = true;
    } else {
      this.isbehalf = false;
    }

    console.log(this.isbehalf);
  }


  onChangeCategory(event): void {
    console.log( 'cate ', event.target.value);
    this.getGeneralSubCategory(event.target.value);
  }


  getGeneralSubCategory(subCategID): void {
    this.subCategList = [];
    const temp = {
      cat_id: subCategID,
      status: 1
    };
    this.queryServe.getSubCategory(temp).subscribe(res => {
      this.subCategstatus = res;
      if (this.subCategstatus.status) {
        this.subCategList = this.subCategstatus.data;
        if(this.subcate != ''){
          this.queryForm.patchValue({
            sub_cat1 : this.subcate,
         });
        }
      } else {
        this.notifyService.showInfo(this.subCategstatus.msg, 'Info!');
      }
    }, err => {
      this.notifyService.showError('Internal Server Error', 'Error!');
    });
  }

  getSub2Category(event): void {
    this.subCateg2List = [];

    this.queryServe.getSub2Category(event.target.value).subscribe(res => {
      this.subCateg2status = res;
      if (this.subCateg2status.status) {
        this.subCateg2List = this.subCateg2status.data;
      } else {
        this.notifyService.showInfo(this.subCateg2status.msg, 'Info!');
      }
    }, err => {
      this.notifyService.showError('Internal Server Error', 'Error!');
    });
  }

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.Img = file;
    }
  }


  search_emp(ev): void {
    // this.addAppForm.delete('user_id');
    this.qryEmp = '';
    this.userContact = {};
    if (ev.value !== '' && ev.value !== undefined) {
      this.queryForm.get('emp').reset();
      this.qryEmp = ev.value;
      // this.addAppForm.append('user_id', ev.value);
      this.queryServe.getEmployeeDetails(ev.value).subscribe((data) => {
        this.result = data;
        if (this.result.status) {
          if (this.result.data.address) {
            this.userAdd = this.result.data.address[0];
          } else {
            this.userAdd = {};
          }

          if (this.result.data.contacts) {
            this.userContact = this.result.data.contacts[0];
          } else {
            this.userContact = {};
          }
        } else {
          this.userAdd = {};
          this.userContact = {};
        }
      });
    }
  } // end of function


  get_emp(ev): void {

    if (ev !== '' && ev !== undefined) {

      this.queryServe.getEmployeeDetails(ev).subscribe((data) => {
        console.log(data);
        this.result2 = data;
        if (this.result2.status) {
          this.Empname = this.result2.data.det.name;
          this.Empstatus= this.result2.data.det.status;
          if (this.result2.data.address) {
            this.userAdd = this.result2.data.address[0];
          } else {
            this.userAdd = {};
          }

          if (this.result2.data.address) {
            this.Empcontact = this.result2.data.contacts[0];
          } else {
            this.Empcontact = {};
          }
        } else {
          this.userAdd = {};
          this.Empcontact = {};
        }
        // if (data['status']) {
        //   console.log(data['data'].det);
        //   this.Empname = data['data'].det['name'];
        //   console.log(data);
        //   if (data['data'].address) {
        //     this.userAdd = data['data'].address[0];
        //   } else {
        //     this.userAdd = {};
        //   }

        //   if (data['data'].address) {
        //     this.Empcontact = data['data'].contacts[0];
        //   } else {
        //     this.Empcontact = {};
        //   }


        // } else {
        //   this.userAdd = {};
        //   this.Empcontact = {};
        // }

      });
    }
  }// end of function

  get emp_id(): any { return this.queryForm.get('emp_id').value; }
  getEmps(event): void {
    this.searchEmps = [];
    this.empID = '';
    let val =  event.target.value;
    if(val.length<4){
      return;
    }
    if (val.length == 0){
      this.searchEmps = [];
      return;
    }
    try{

      this.subscription.unsubscribe();
    }catch(err){

    }

    this.subscription = this.generalServ.getEmpsAll({key : val}).subscribe(res => {
      console.log(res);
      this.searchEmps = res.data;
    },
    err => {

    });
  }

  selectEmp(event): void {
    if (event.target.value) {
      this.empID = event.target.value;
      const tmp = this.searchEmps.filter(val => val.id == event.target.value);
      this.queryForm.patchValue({
        emp_id: tmp[0].username + ' - ' + tmp[0].name
      });
      this.searchEmps = [];
    } else {
      this.empID = '';
    }
  }


  // onExcelChange(event): void {
  //   if (event.target.files.length > 0) {
  //     const file = event.target.files[0];
  //     this.excelfile = file;

  //     this.queryForm.patchValue({
  //       is_excel : 1
  //     });
  //   }
  // }

  excelRead(event): void {

    // this.spinner.show();
    const workbook = new Excel.Workbook();
    const target: DataTransfer = (event.target) as DataTransfer;
    if (target.files.length !== 1) {
      // this.spinner.hide();
      throw new Error('Cannot use multiple files');
    }
    // this.uploading = true;
    const parent =  this;
    const arryBuffer = new Response(target.files[0]).arrayBuffer();
    arryBuffer.then(data => {
      workbook.xlsx.load(data)
        .then(() => {
          const worksheet = workbook.getWorksheet();
          parent.excelCC  = [];
          // tslint:disable-next-line: typedef
          worksheet.eachRow(function (row, rowNumber) {
            parent.excelCC.push(row.values[1]);
          });
          this.excelfile = parent.excelCC;

          this.queryForm.patchValue({
            is_excel : 1
          });

        });
    });
  }

  addQuery(): void {
    this.submitted = true;
    if (this.queryForm.invalid) {
      return;
    } else {
      this.loading = true;
      const addAppForm = new FormData();
      addAppForm.append('img[]', this.Img);

      let behalf;
      behalf = this.isbehalf ? '1' : '0';

      if (this.isbehalf) {
        addAppForm.append('user_id', this.empID);
        addAppForm.append('excel_data', JSON.stringify(this.excelfile));
        addAppForm.append('is_excel', this.queryForm.get('is_excel').value);
      }
      addAppForm.append('cat_id', this.queryForm.get('category').value);
      addAppForm.append('subcat1_id', this.queryForm.get('sub_cat1').value);
      addAppForm.append('subcat2_id', this.queryForm.get('sub_cat2').value);
      addAppForm.append('qry_desc', this.queryForm.get('remark').value);
      addAppForm.append('priority', this.queryForm.get('priority').value);
      addAppForm.append('is_on_behalf', behalf);
      console.log('cusb_cat1',this.queryForm.get('sub_cat1'));
      if (this.queryForm.get('sub_cat1').value === '7') {
        addAppForm.append('acc_type', this.queryForm.get('acc_type').value);
        addAppForm.append('bank_id', this.queryForm.get('bank_id').value);
        addAppForm.append('acc_no', this.queryForm.get('acc_no').value);
        addAppForm.append('ifsc_code', this.queryForm.get('ifsc_code').value);
      }
      
      if (this.queryForm.get('sub_cat1').value === '114') {
        addAppForm.append('rem_acc_type', this.queryForm.get('rem_acc_type').value);
        addAppForm.append('rem_bank_id', this.queryForm.get('rem_bank_id').value);
        addAppForm.append('rem_acc_no', this.queryForm.get('rem_acc_no').value);
        addAppForm.append('rem_ifsc_code', this.queryForm.get('rem_ifsc_code').value);
      }
      
      if (this.queryForm.get('sub_cat1').value == 109) {  
        addAppForm.append('first_name', this.queryForm.get('first_name').value);
        addAppForm.append('last_name', this.queryForm.get('last_name').value);
        addAppForm.append('dob', this.queryForm.get('dob').value);
        addAppForm.append('gender', this.queryForm.get('gender').value);
        addAppForm.append('marital', this.queryForm.get('marital').value);
        addAppForm.append('is_pwd', this.queryForm.get('is_pwd').value);
        addAppForm.append('depart', this.queryForm.get('depart').value);

        this.FName = this.queryForm.get('first_name').value;
        this.LName = this.queryForm.get('last_name').value;
        this.Dob = this.queryForm.get('dob').value;
        this.Gender = this.queryForm.get('gender').value;
        this.Marital = this.queryForm.get('marital').value;
        this.IsPwd = this.queryForm.get('is_pwd').value;
        this.Deprt = this.queryForm.get('depart').value;

        if( this.FName == '' && this.LName == '' && this.Dob == '' && this.Gender == '' && this.Marital == '' && this.IsPwd == '' && this.Deprt == ''){
          Swal.fire('Kindly fill atleast any one User Personal Details!');
          return;
        }
      }
      
      if( (this.Empstatus=='0') || (this.Empstatus==0))
      {
        addAppForm.append('source_type', 'ALUMNI PORTAL');
      }
      else
      {
        addAppForm.append('source_type', 'PORTAL');
      }
      
      console.log('excel' , this.queryForm.get('is_excel').value )
      
      
      // return;
      if(this.queryForm.get('is_excel').value == 1) {
        this.queryServe.addQueryBulkExcel(addAppForm).subscribe( res => {
          this.loading = false;
          this.submitted = false;
          this.result = res;
          if (this.result.status) {
            this.queryForm.reset();
            this.notifyService.showSuccess(this.result.msg, 'Success!');
          } else {
            this.notifyService.showInfo(this.result.msg, 'Info!');
          }
        }, err => {
          this.loading = false;
          this.submitted = false;
          this.notifyService.showError('Internal server error', 'Error!');
        });
      } else {

        this.queryServe.AddQuery(addAppForm).subscribe(res => {
          // this.addAppForm = new FormData();
          this.loading = false;
          this.submitted = false;
          this.result = res;
          if (this.result.status) {
            this.queryForm.reset();
            this.notifyService.showSuccess(this.result.msg, 'Success!');
            // this.router.navigate(['/queries/master']);
          } else {
            this.notifyService.showInfo(this.result.msg, 'Info!');
          }
        }, err => {
          // this.addAppForm = new FormData();
          this.loading = false;
          this.submitted = false;
          this.notifyService.showError('Internal server error', 'Error!');
        });
      }
    }// end of else
  }// end of function


  mandateDoc(): void{
        console.log( 'll ', this.queryForm.get('sub_cat1').value) 
        // {
        //   this.placeholderText = 'Enter Employee Name , Father Name , DOD , Gender , Marital Status , Physical Disability';
        // }

      if (this.queryForm.get('sub_cat1').value === '7') {
        this.userDetailsForm = true;
        this.userPersnalDetailsForm = false;
        this.reiumbureseBankForm = false;
        // this.queryForm.get('acc_no').setValidators([
        //   Validators.required,
        //   Validators.minLength(12),
        //   Validators.maxLength(12),
        //   Validators.pattern('^[0-9]*$')]);
        this.queryForm.get('acc_no').setValidators([Validators.required]);
          // Validators.pattern('^[0-9]*$')]);
        this.queryForm.get('acc_no').updateValueAndValidity();
        this.queryForm.get('acc_type').setValidators([Validators.required]);
        this.queryForm.get('acc_type').updateValueAndValidity();
        this.queryForm.get('bank_id').setValidators([Validators.required]);
        this.queryForm.get('bank_id').updateValueAndValidity();
        this.queryForm.get('ifsc_code').setValidators(Validators.compose(
          [Validators.minLength(11), Validators.maxLength(11), Validators.required]
          ));
        this.queryForm.get('ifsc_code').updateValueAndValidity();

      } else if (this.queryForm.get('sub_cat1').value === '114') { 
          this.userDetailsForm = false;
          this.userPersnalDetailsForm = false;
          this.reiumbureseBankForm = true;
          this.queryForm.get('rem_acc_no').setValidators([Validators.required]);
          this.queryForm.get('rem_acc_no').updateValueAndValidity();
          this.queryForm.get('rem_acc_type').setValidators([Validators.required]);
          this.queryForm.get('rem_acc_type').updateValueAndValidity();
          this.queryForm.get('rem_bank_id').setValidators([Validators.required]);
          this.queryForm.get('rem_bank_id').updateValueAndValidity();
          this.queryForm.get('rem_ifsc_code').setValidators(Validators.compose(
            [Validators.minLength(11), Validators.maxLength(11), Validators.required]
            ));
          this.queryForm.get('rem_ifsc_code').updateValueAndValidity();
      } else if (this.queryForm.get('sub_cat1').value === '109') { 
        this.getPWDList();
        this.getMaritalList();
        this.getGenderList();
        this.getDepartments();
        this.userDetailsForm = false;
        this.userPersnalDetailsForm = true;
        this.reiumbureseBankForm = false;
        
      } else {
        this.userDetailsForm = false;
        this.userPersnalDetailsForm = false;
        this.reiumbureseBankForm = false;
        this.queryForm.get('acc_no').clearValidators();
        this.queryForm.get('acc_no').updateValueAndValidity();
        this.queryForm.get('acc_type').clearValidators();
        this.queryForm.get('acc_type').updateValueAndValidity();
        this.queryForm.get('bank_id').clearValidators();
        this.queryForm.get('bank_id').updateValueAndValidity();
        this.queryForm.get('ifsc_code').clearValidators();
        this.queryForm.get('ifsc_code').updateValueAndValidity();
        this.queryForm.get('rem_acc_no').clearValidators();
        this.queryForm.get('rem_acc_no').updateValueAndValidity();
        this.queryForm.get('rem_acc_type').clearValidators();
        this.queryForm.get('rem_acc_type').updateValueAndValidity();
        this.queryForm.get('rem_bank_id').clearValidators();
        this.queryForm.get('rem_bank_id').updateValueAndValidity();
        this.queryForm.get('rem_ifsc_code').clearValidators();
        this.queryForm.get('rem_ifsc_code').updateValueAndValidity();

      }
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.subCategList.length; i++) {
          const el = this.subCategList[i];
          console.log(el);
          // tslint:disable-next-line: triple-equals
          if (el.subcat1_id == this.queryForm.get('sub_cat1').value){
            // tslint:disable-next-line: triple-equals
            if (el.is_document == 0) {
              console.log(this.queryForm.get('sub_cat1').value);
              console.log(this.queryForm.controls);
              this.queryForm.get('doc').clearValidators();
              this.queryForm.get('doc').updateValueAndValidity();

            // tslint:disable-next-line: triple-equals
            } else if (el.is_document == 1) {
              console.log(typeof this.queryForm.get('sub_cat1').value);
              console.log(this.queryForm.controls);
              this.queryForm.get('doc').setValidators([Validators.required]);
              this.queryForm.get('doc').updateValueAndValidity();
              console.log('mandatory');
            }
            return;
          }
      }// end of for loop



  }

  getBanks(): void {
    this.generalServ.getBanks().subscribe(res => {
      this.result = res;
      this.getBankName = this.result.data;
    });
  }
  getAccountTypes(): void {
    this.generalServ.getAccountTypes().subscribe(res => {
      this.result = res;
      this.getAccType = this.result.data;
    });
  }


  onCloseModal(): void {
    $('#accUpdationModal').modal('hide');
  }




}
